import { render } from "./EmptyPage.vue?vue&type=template&id=0b5140d5&scoped=true"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"

import "./EmptyPage.vue?vue&type=style&index=0&id=0b5140d5&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5140d5"]])

export default __exports__